import axios from 'axios'
import qs from 'qs'
import config from '@/config'

var fetch = axios.create({
    baseURL: config.baseUri,
    // withCredentials : false,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 30000,
    params: {
        lang: localStorage.Lang || 'en'
    }
})

fetch.interceptors.request.use(
    config => {
        config.headers['lang'] = localStorage.Lang || 'en'
        if (config.method === 'get') {
            // 解决reload问题
            config.params.lang = localStorage.Lang || 'en'
        } else if (config.method === 'post') {
            config.params.lang = null

            config.data.lang = localStorage.Lang || 'en'
            config.data = qs.stringify(config.data)
        }

        return config
    },
    error => {
        return Promise.reject({
            message: error.message
        })
    }
)

fetch.interceptors.response.use(function (res) {
    if (res.data && res.data.code === 'success') {
        return Promise.resolve(res.data)
    } else {
        return Promise.reject(res.data)
    }
}, function (error) {
    console.log(error)
    return Promise.reject({
        message: error.message
    })
})

export default fetch
